import { useRef } from 'react';
import { useDisclosure } from '@chakra-ui/react';

import asBentoPage from 'common/bento/hoc/asBentoPage';
import Button from 'components/_core/Button';
import AddressForm from 'features/Onboarding/components/AddressForm';
import { AddressFormElement } from 'features/Onboarding/components/AddressForm/AddressForm';
import { AddressSchema } from 'features/Onboarding/components/AddressForm/addressSchema';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

import CapitalDepositQuestionPage from '../../components/QuestionPage';
import { CapitalDepositPage } from '../../types';
import locales from './locales';

type CompanyAddressProps = {
  onSubmit: (values: AddressSchema) => void;
  formData: AddressSchema;
  isSending: boolean;
  isMandatee: boolean;
} & CapitalDepositPage;

const CompanyAddress = asBentoPage<CompanyAddressProps>(
  ({ formData, isMandatee, isSending, Layout, onPrev, onSubmit, progress }) => {
    const addressOverlay = useDisclosure();

    const addressFormRef = useRef<AddressFormElement>(null);

    const handlePrev = () => {
      if (addressFormRef.current?.isEditing) {
        addressFormRef.current?.reset();
        return;
      }
      onPrev();
    };

    const mandateeLocaleKey = isMandatee ? 'mandatee' : 'nonMandatee';

    return (
      <Layout
        nav={
          <OBNavigation
            isCollapsed={addressOverlay.isOpen ? true : undefined}
            onClose={addressOverlay.isOpen ? addressOverlay.onClose : undefined}
            onPrev={handlePrev}
          />
        }
      >
        <CapitalDepositQuestionPage
          button={
            addressOverlay.isOpen ? null : (
              <Button
                icon="arrow-right"
                isLoading={isSending}
                onClick={addressFormRef.current?.submit}
              >
                {locales.ctaSubmit}
              </Button>
            )
          }
          progress={progress}
        >
          <AddressForm
            addressOverlayClose={addressOverlay.onClose}
            initialValues={formData}
            isOverlayOpen={addressOverlay.isOpen}
            isSending={isSending}
            locales={{
              description: locales.description[mandateeLocaleKey],
              title: locales.title[mandateeLocaleKey],
            }}
            noSubmitButton
            onContinue={onSubmit}
            onOverlayClose={addressOverlay.onClose}
            onOverlayOpen={addressOverlay.onOpen}
            ref={addressFormRef}
          />
        </CapitalDepositQuestionPage>
      </Layout>
    );
  },
);

export default CompanyAddress;
